import React, { useEffect, useState, useCallback } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Box, Select, Button, TextInput, TextArea, Text, MaskedInput, ResponsiveContext } from 'grommet';

import { loadData } from '../../../actions/client-details';
import { sendManifestation, changeField } from '../../../actions/form-manifestation';
import { searchCityOptions, searchZipcodeOptions } from '../../../actions/select-options';

import { ErrorForm, ErrorLoading, Loading } from '../../../components';
import { decryptAes } from '../../../utils';

import selectManifestationTypes from '../../../constants/select-manifestation-type';
import urlRoutes from '../../../config/url-routes';

const Form = (props) => {
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [zipcodeFounded, setZipcodeFounded] = useState(null);

  const {
    encryptedClientDetail,
    clientDetailError,
    changeField,
    loadData,
    searchCityOptions,
    searchZipcodeOptions,
    sendManifestation,

    cityOptions,
    addressOptions,

    loadingPostForm,
    postListError,

    individualRegistration,
    name,
    telephone,
    email,
    typeId,
    description,

    zipcode,
    addressType,
    address,
    addressNumber,
    addressComplement,
    district,
    districtId,
    cityId,
    city,
    stateId,
    state,


  } = props;

  useEffect(() => {
    const { identifier } = props.match.params;

    if(encryptedClientDetail) return;

    loadData(identifier);
  }, [
    encryptedClientDetail, loadData, props.match.params
  ]);

  useEffect(() => {
    if(!addressOptions) {
      return;
    }

    const location = addressOptions[0];

    const addressFoundAndValid = Boolean(addressOptions.length === 1 &&
      location.address &&
      location.districtId &&
      location.cityId &&
      location.stateId);

    if(!addressFoundAndValid)
    {
      changeField({ fieldName: 'addressType', value: null });
      changeField({ fieldName: 'address', value: null });
      changeField({ fieldName: 'district', value: null });
      changeField({ fieldName: 'districtId', value: null });
      changeField({ fieldName: 'cityId', value: null });
      changeField({ fieldName: 'city', value: null });
      changeField({ fieldName: 'stateId', value: null });
      changeField({ fieldName: 'state', value: null });

      setZipcodeFounded(false);

      return;
    }

    changeField({ fieldName: 'addressType', value: location.addressType });
    changeField({ fieldName: 'address', value: location.address });
    changeField({ fieldName: 'district', value: location.district });
    changeField({ fieldName: 'districtId', value: location.districtId });
    changeField({ fieldName: 'cityId', value: location.cityId });
    changeField({ fieldName: 'city', value: location.city });
    changeField({ fieldName: 'stateId', value: location.stateId });
    changeField({ fieldName: 'state', value: location.state });

    setZipcodeFounded(true);
  }, [
    addressOptions,
    changeField,
  ]);

  useEffect(() => {
    const enable = (
      name &&
      telephone &&
      typeId &&
      description &&
      (districtId || district) &&
      zipcode &&
      address &&
      addressNumber
    );

    setEnableSubmit(enable);
  }, [
    name,
    telephone,
    typeId,
    description,
    districtId,
    district,
    zipcode,
    address,
    addressNumber,
  ]);


  const callbackPostSuccess = useCallback(() => {
    const { identifier } = props.match.params;
    const { history } = props;

    history.push(urlRoutes.manifestationThankUrl.replace(/:identity/gi, identifier));
  }, [props])

  const handlePost = useCallback(formParams => {
    sendManifestation({
      formParams,
      callbackSuccess: callbackPostSuccess,
    });
  }, [sendManifestation, callbackPostSuccess]);

  const onSearchCities = useCallback(text => {
    if (text.length < 2) return;

    searchCityOptions({
      name: text
    });
  }, [searchCityOptions]);

  const onSearchZipcode = useCallback(text => {
    if (text.length < 9) return;

    searchZipcodeOptions({
      zipcode: text,
    });
  }, [searchZipcodeOptions]);



  if(!clientDetailError && !encryptedClientDetail) {
    return <Loading />;
  }

  if(clientDetailError) {
    return <ErrorLoading />;
  }

  const decipheredData = encryptedClientDetail ? decryptAes(encryptedClientDetail) : null;
  const dataJson = JSON.parse(decipheredData);


  return (
    <ResponsiveContext.Consumer>
      {size => (
        <>
          <Box
            align='center'
          >
            <Box
              width='xlarge'
              direction={
                size === 'small' ? 'column' : 'row'
              }
              gap={
                size === 'medium' ? 'xsmall' : 'large'
              }
            >
              {/* form */}
              <Box
                align='start'
                width='large'
                pad={{ horizontal: 'medium' }}
              >

                {/* cpf, nome */}
                <Box
                  direction={ size === 'small' ? 'column' : 'row' }
                  margin={{ bottom: 'small' }}
                  gap='small'
                  fill='horizontal'
                >
                  <Box
                    gap='xxsmall'
                    fill
                  >
                    <Text size='small' color='dark-3'>CPF</Text>

                    <MaskedInput
                      mask={[
                        { length: 3, regexp: /\d/ },
                        { fixed: '.' },
                        { length: 3, regexp: /\d/ },
                        { fixed: '.' },
                        { length: 3, regexp: /\d/ },
                        { fixed: '-' },
                        { length: 2, regexp: /\d/ }
                      ]}
                      placeholder=' '
                      value={individualRegistration ?? ''}
                      onChange={ event => changeField({ fieldName: 'individualRegistration', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='individualRegistration' />
                  </Box>

                  <Box
                    gap='xxsmall'
                    fill
                  >
                    <Text size='small' color='dark-3'>Nome *</Text>

                    <TextInput
                      value={name ?? ''}
                      onChange={ event => changeField({ fieldName: 'name', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='name' />
                  </Box>
                </Box>


                {/* telfone, e-mail */}
                <Box
                  direction={ size === 'small' ? 'column' : 'row' }
                  margin={{ bottom: 'small' }}
                  gap='small'
                  fill='horizontal'
                >
                  <Box
                    gap='xxsmall'
                    fill
                  >
                    <Text size='small' color='dark-3'>Telefone *</Text>

                    <MaskedInput
                      mask={[
                        { fixed: '(' },
                        { length: 2, regexp: /\d/ },
                        { fixed: ')' },
                        { fixed: ' ' },
                        { length: 4, regexp: /\d/ },
                        { fixed: '-' },
                        { length: [4, 5], regexp: /\d/ }
                      ]}
                      placeholder=' '
                      value={telephone ?? ''}
                      onChange={ event => changeField({ fieldName: 'telephone', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='telephone' />
                  </Box>

                  <Box
                    gap='xxsmall'
                    fill
                  >
                    <Text size='small' color='dark-3'>E-mail</Text>

                    <TextInput
                      value={email ?? ''}
                      onChange={ event => changeField({ fieldName: 'email', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='email' />
                  </Box>
                </Box>


                <Box
                  flex={{ shrink: 0 }}
                  margin={{ top: 'medium', bottom: 'small' }}
                >
                  <Text size='medium' color='dark-1'>
                    Endereço
                  </Text>
                </Box>


                {/* CEP */}
                <Box
                  fill='horizontal'
                  flex={{ shrink: 0 }}
                  gap='xxsmall'
                  margin={{ bottom: 'small' }}
                >
                  <Text size='small' color='dark-3'>CEP *</Text>

                  <MaskedInput
                    mask={[
                      { length: 5, regexp: /\d/ },
                      { fixed: '-' },
                      { length: 3, regexp: /\d/ }
                    ]}
                    placeholder=' '
                    value={zipcode ?? ''}
                    onChange={ event => {
                        changeField({
                          fieldName: 'zipcode',
                          value: event.target.value,
                        });

                        onSearchZipcode(event.target.value);
                      }
                    }
                  />

                  <ErrorForm errorsList={postListError} fieldName='zipcode' />
                </Box>

                {zipcodeFounded && (
                  <Box
                    round='xsmall'
                    pad='medium'
                    margin={{ bottom: 'small' }}
                    fill='horizontal'
                    background='light-2'
                  >
                    <Text size='small' color='dark-2'>{addressType} {address}, {district}</Text>
                    <Text size='small' color='dark-2'>{city}, {state}</Text>
                  </Box>
                )}

                {/* Rua */}
                {(zipcodeFounded === false) && (
                  <Box
                    fill='horizontal'
                    flex={{ shrink: 0 }}
                    gap='xxsmall'
                    margin={{ bottom: 'small' }}
                  >
                    <Text size='small' color='dark-3'>Logradouro *</Text>

                    <TextInput
                      value={address ?? ''}
                      onChange={ event => changeField({ fieldName: 'address', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='address' />
                  </Box>
                )}

                {/* Número, complemento */}
                <Box
                  direction={ size === 'small' ? 'column' : 'row' }
                  margin={{ bottom: 'small' }}
                  gap='small'
                  fill='horizontal'
                >
                  <Box
                    gap='xxsmall'
                    width='medium'
                  >
                    <Text size='small' color='dark-3'>Número *</Text>

                    <TextInput
                      type='number'
                      value={addressNumber ?? ''}
                      placeholder='Apenas números'
                      onChange={ event => changeField({ fieldName: 'addressNumber', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='addressNumber' />
                  </Box>

                  <Box
                    gap='xxsmall'
                    width='large'
                  >
                    <Text size='small' color='dark-3'>Complemento</Text>

                    <TextInput
                      value={addressComplement ?? ''}
                      placeholder='Apto, bloco...'
                      onChange={ event => changeField({ fieldName: 'addressComplement', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='addressComplement' />
                  </Box>
                </Box>

                {/* bairro */}
                {zipcodeFounded === false && (
                  <Box
                    fill='horizontal'
                    flex={{ shrink: 0 }}
                    gap='xxsmall'
                    margin={{ bottom: 'small' }}
                  >
                    <Text size='small' color='dark-3'>Bairro *</Text>

                    <TextInput
                      value={district ?? ''}
                      onChange={ event => changeField({ fieldName: 'district', value: event.target.value }) }
                    />

                    <ErrorForm errorsList={postListError} fieldName='district' />
                  </Box>
                )}

                {/* cidade */}
                {zipcodeFounded === false && (
                  <Box
                    fill='horizontal'
                    flex={{ shrink: 0 }}
                    gap='xxsmall'
                    margin={{ bottom: 'small' }}
                  >
                    <Text size='small' color='dark-3'>Cidade *</Text>

                    <Select
                      emptySearchMessage='Selecione uma opção'
                      options={cityOptions || []}
                      value={cityId ?? ''}
                      labelKey='name'
                      valueKey={{ key: 'id', reduce: true }}
                      onChange={
                        ({ option }) => {
                          const {
                            id,
                            stateId,
                          } = option;

                          changeField({ fieldName: 'cityId', value: id });
                          changeField({ fieldName: 'stateId', value: stateId });
                        }
                      }
                      onSearch={text => onSearchCities(text)}
                    >
                      {(option, index, options, { selected }) => {
                        return (
                          <Box
                            pad={{ horizontal: 'small', vertical: 'small' }}
                            gap='small'
                            direction='row'
                            align='baseline'
                          >
                            <Text
                              size='medium'
                              color='dark-1'
                              weight={selected ? 'bold' : 'normal'}
                            >
                              {option.name}
                            </Text>

                            <Text size='small' color='dark-6' weight={selected ? 'bold' : 'normal'}>
                              {option.stateAbbrev}
                            </Text>
                          </Box>
                        )
                      }}
                    </Select>

                    <ErrorForm errorsList={postListError} fieldName='cityId' />
                  </Box>
                )}


                <Box
                  flex={{ shrink: 0 }}
                  margin={{ top: 'medium', bottom: 'small' }}
                >
                  <Text size='medium' color='dark-1'>
                    Sua manifestação
                  </Text>
                </Box>


                {/* Tipo */}
                <Box
                  fill='horizontal'
                  flex={{ shrink: 0 }}
                  gap='xxsmall'
                  margin={{ bottom: 'small' }}
                >
                  <Text size='small' color='dark-3'>Tipo *</Text>

                  <Select
                    options={selectManifestationTypes}
                    value={typeId ?? ''}
                    valueKey={{ key: 'id', reduce: true }}
                    labelKey='name'
                    emptySearchMessage='Selecione uma opção'
                    onChange={({ value: nextValue }) => changeField({ fieldName: 'typeId', value: nextValue })}
                  />

                  <ErrorForm errorsList={postListError} fieldName='typeId' />
                </Box>


                {/* manifestação */}
                <Box
                  fill='horizontal'
                  flex={{ shrink: 0 }}
                  gap='xxsmall'
                  margin={{ bottom: 'small' }}
                >
                  <Text size='small' color='dark-3'>Descreva um pouco sobre sua manifestação *</Text>

                  <TextArea
                    resize='vertical'
                    rows={5}
                    maxLength={500}
                    value={description ?? ''}
                    onChange={ event => changeField({ fieldName: 'description', value: event.target.value }) }
                  />

                  <ErrorForm errorsList={postListError} fieldName='description' />
                </Box>


                <Box
                  margin={{ bottom: 'small' }}
                >
                  <Text
                    size='xsmall'
                    color='dark-3'
                  >
                    Ao clicar em "Enviar", você concorda com os Termos de uso e com a Política de Privacidade.
                  </Text>
                </Box>


                <Box
                  direction='row'
                  margin={{ bottom: 'large' }}
                  width='xlarge'
                >
                  <Button
                    fill='horizontal'
                    primary
                    color='brand'
                    label={ !loadingPostForm ? 'Enviar' : 'Enviando...' }
                    disabled={
                      loadingPostForm || !enableSubmit
                    }
                    onClick={() => {
                      handlePost({
                        clientId: dataJson.clientId,
                        individualRegistration,
                        name,
                        telephone,
                        email,
                        typeId,
                        description,

                        zipcode,
                        addressType,
                        address,
                        addressNumber,
                        addressComplement,
                        district,
                        districtId,
                        cityId,
                        stateId,
                      })
                    }}
                  />
                </Box>
              </Box>

              {/* descrição */}
              {size === 'small' || size === 'medium' ? null : (
                <Box
                  gap='medium'
                  width={ size === 'small' ? 'large' : 'medium' }
                  pad={{ horizontal: 'medium' }}
                >
                  <Text
                    size='medium'
                    color='dark-1'
                    weight='bold'
                  >
                    Começe a colaborar para melhorar a sua cidade.
                  </Text>

                  <Text
                    size='small'
                    color='dark-2'
                  >
                    Fique tranquilo suas informações estarão seguras com a gente.
                  </Text>

                  <Text
                    size='small'
                    color='dark-2'
                  >
                    Sua manifestação estará disponível para o representando político que escolheu
                    e ele poderá entrar em contato com você para mais detalhes.
                  </Text>

                  <Text
                    size='small'
                    color='dark-2'
                  >
                    Ao final do cadastro iremos gerar um número de protocolo,
                    guarde ele para facilitar o seu contato com o parlamentar afim de saber a situação.
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        </>
      )}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ clientDetails, formManifestation, selectOptions }) => ({
  encryptedClientDetail: clientDetails.encryptedClientDetail,
  clientDetailError: clientDetails.clientDetailError,

  cityOptions: selectOptions.cityOptions,
  addressOptions: selectOptions.addressOptions,

  loadingPostForm: formManifestation.loadingPostForm,
  postListError: formManifestation.postListError,

  individualRegistration: formManifestation.individualRegistration,
  name: formManifestation.name,
  telephone: formManifestation.telephone,
  email: formManifestation.email,
  typeId: formManifestation.typeId,
  description: formManifestation.description,

  zipcode: formManifestation.zipcode,
  addressType: formManifestation.addressType,
  address: formManifestation.address,
  addressNumber: formManifestation.addressNumber,
  addressComplement: formManifestation.addressComplement,
  district: formManifestation.district,
  districtId: formManifestation.districtId,
  cityId: formManifestation.cityId,
  city: formManifestation.city,
  stateId: formManifestation.stateId,
  state: formManifestation.state,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    loadData,
    changeField,
    sendManifestation,
    searchCityOptions,
    searchZipcodeOptions,
  }, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form));
